import {
  Modal,
  ProgressIndicator,
  ProgressStep,
} from 'carbon-components-react';
import React, { useState, useEffect } from 'react';
import Step1 from '../../Molecules/Steps/Step1';
import Step2 from '../../Molecules/Steps/Step2';
import Step3 from '../../Molecules/Steps/Step3';
import Step4 from '../../Molecules/Steps/Step4';
import Step5 from '../../Molecules/Steps/Step5';
import { QuesIDProps, que5ValueProps } from '../../Maas360Estimator';
import { ArrowRight24, Restart20 } from '@carbon/icons-react';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'src/apps/maas360-estimator/locales/messages';
import Selection from '../../Molecules/Selection/Selection';
import Result from '../../Molecules/Result/Result';
import TopMatch from '../../Molecules/TopMatch/TopMatch';
import PackageDetail from '../../Molecules/PackageDetail/PackageDetail';
import { DELUX_MATCH, marketplaceUrl } from '../../../constants/default';
import Cta from '../../Molecules/Cta/Cta';
import Switcher from '../../Molecules/Switcher/Switcher';
import usePrice from 'src/apps/maas360-estimator/hooks/usePrice';
import { segmentsTracking } from 'src/common/lib/tracker';
import { useCookiesURL } from 'src/common/hooks/widgets/useCookiesURL';
import { useSetCookie } from 'src/apps/maas360-estimator/hooks/useSetCookie';
import BusinessPartner from 'src/common/components/BusinessPartner/BusinessPartner';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';

type PopUpModalProps = {
  langCode: string;
  bpName: string;
  logo: string;
  companyId: string;
  open: boolean;
  handleCloseModal: () => void;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  currentQuestion: string;
  setCurrentQuestion: React.Dispatch<React.SetStateAction<string>>;
  isRequired: boolean;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  que1Value: string;
  setQue1Value: React.Dispatch<React.SetStateAction<string>>;
  que2Value: string;
  setQue2Value: React.Dispatch<React.SetStateAction<string>>;
  que3Value: string;
  setQue3Value: React.Dispatch<React.SetStateAction<string>>;
  que4Value: number;
  setQue4Value: React.Dispatch<React.SetStateAction<number>>;
  que5Value: que5ValueProps;
  setQue5Value: React.Dispatch<React.SetStateAction<que5ValueProps>>;
  trackQuesID: QuesIDProps;
  setTrackQuesID: React.Dispatch<React.SetStateAction<QuesIDProps>>;
  topMatch: string;
  setTopMatch: React.Dispatch<React.SetStateAction<string>>;
  showTopMatch: boolean;
  setShowTopMatch: React.Dispatch<React.SetStateAction<boolean>>;
  noAdditionalReq: boolean;
  setNoAdditionalReq: React.Dispatch<React.SetStateAction<boolean>>;
  deluxe: boolean;
  formComplete: boolean;
  setDeluxe: React.Dispatch<React.SetStateAction<boolean>>;
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setModel2: React.Dispatch<React.SetStateAction<boolean>>;
  setFormComplete: React.Dispatch<React.SetStateAction<boolean>>;
  setTopMatchDetails: React.Dispatch<React.SetStateAction<topMatchProps>>;
  handleUrxForm: () => void;
  topMatchDetails: topMatchProps;
  model2: boolean;
  localeCode: string;
  reset: () => void;
  currency: string;
  country: string;
};

export type topMatchProps = {
  title: string;
  plan: string;
  shortDesc: string;
  desc: string;
  icon: string;
  price: string;
  url: string;
  signUpUrl: string;
};

export type deluxeProps = {
  title: string;
  plan: string;
  shortDesc: string;
  icon: string;
  price: string;
  url: string;
};

const deluxeState = {
  title: '',
  plan: '',
  shortDesc: '',
  icon: '',
  price: '',
  url: '',
};

const Assessment = ({
  open,
  handleCloseModal,
  step,
  que1Value,
  setQue1Value,
  que2Value,
  setQue2Value,
  setStep,
  isRequired,
  setIsRequired,
  que3Value,
  setQue3Value,
  que4Value,
  setQue4Value,
  que5Value,
  setQue5Value,
  trackQuesID,
  setTrackQuesID,
  setTopMatch,
  topMatch,
  setShowTopMatch,
  noAdditionalReq,
  setNoAdditionalReq,
  deluxe,
  setDeluxe,
  topMatchDetails,
  setTopMatchDetails,
  localeCode,
  reset,
  currency,
  country,
  bpName,
  logo,
  handleUrxForm,
}: PopUpModalProps) => {
  const [deluxeData, setDeluxeData] = useState<deluxeProps>(deluxeState);
  const [deluxePkg, setDeluxePkg] = useState(false);
  const [plan, setPlan] = useState('');
  const [packageOption, setPackageOption] = useState(topMatch);
  const cookieURL = useCookiesURL();
  const [enterprisePrice, deluxePrice, premierPrice, essentialPrice] = usePrice(
    { localeCode, currency, country },
  );

  const [invalidQ1, setInvalidQ1] = useState(false);
  const [invalidQ2, setInvalidQ2] = useState(false);
  const [invalidQ3, setInvalidQ3] = useState(false);
  const [invalidQ4, setInvalidQ4] = useState(false);
  const [invalidQ5, setInvalidQ5] = useState(false);

  const isSmall = useSmallBreakpoint('768px');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const checkQ5Value = (options: any) => {
    const selectedItems = options?.multi?.selectedItems;
    if (typeof selectedItems !== 'undefined' && selectedItems.length > 0) {
      return true;
    } else return false;
  };

  const handleReset = () => {
    if (step === 6) {
      const style = window.document.getElementById(
        `${'urx-form-container'}`,
      ) as HTMLDivElement;
      style.style.display = 'none';
    }
    reset();
    setDeluxeData(deluxeState);
    setDeluxePkg(false);
    setPackageOption(topMatch);
    setPlan('');
    setInvalidQ1(false);
    setInvalidQ2(false);
    setInvalidQ3(false);
    setInvalidQ4(false);
    setInvalidQ5(false);
  };

  const handleSegmentTracking = (cta: string) => {
    segmentsTracking('CTA Clicked', {
      pageTitle: 'MaaS360 Plan Assessment',
      object: 'Mass360 page',
      resultValue: 'CTA clicked',
      CTA: cta,
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  const handleTopMatchData = (topMatchName: string) => {
    const title =
      topMatchName === 'Enterprise'
        ? intl.formatMessage(messages.enterprise_title)
        : topMatchName === 'Premier'
        ? intl.formatMessage(messages.premier_title)
        : topMatchName === 'Essentials'
        ? intl.formatMessage(messages.essentials_title)
        : intl.formatMessage(messages.deluxe_title);
    const plan =
      topMatchName === 'Enterprise'
        ? intl.formatMessage(messages.enterprise_plan)
        : topMatchName === 'Premier'
        ? intl.formatMessage(messages.premier_plan)
        : topMatchName === 'Essentials'
        ? intl.formatMessage(messages.essentials_plan)
        : intl.formatMessage(messages.deluxe_plan);
    const shortDesc =
      topMatchName === 'Enterprise'
        ? intl.formatMessage(messages.enterprise_short_desc)
        : topMatchName === 'Premier'
        ? intl.formatMessage(messages.premier_short_desc)
        : topMatchName === 'Essentials'
        ? intl.formatMessage(messages.essentials_short_desc)
        : intl.formatMessage(messages.deluxe_short_desc);
    const desc =
      topMatchName === 'Enterprise'
        ? intl.formatMessage(messages.enterprise_desc)
        : topMatchName === 'Premier'
        ? intl.formatMessage(messages.premier_desc)
        : topMatchName === 'Essentials'
        ? intl.formatMessage(messages.essentials_desc)
        : intl.formatMessage(messages.deluxe_desc);
    const icon =
      topMatchName === 'Enterprise'
        ? intl.formatMessage(messages.enterprise_icon)
        : topMatchName === 'Premier'
        ? intl.formatMessage(messages.premier_icon)
        : topMatchName === 'Essentials'
        ? intl.formatMessage(messages.essentials_icon)
        : intl.formatMessage(messages.deluxe_icon);
    setTopMatchDetails({
      ...topMatchDetails,
      title,
      plan,
      shortDesc,
      desc,
      icon,
      signUpUrl: marketplaceUrl.signUp,
    });
  };

  const intl = useIntl();

  useEffect(() => {
    if (topMatch) {
      handleTopMatchData(topMatch);
    }
  }, [topMatch, open]);

  const determineTopMatch = () => {
    const { Q1, Q2 } = trackQuesID;
    switch (true) {
      case Q1 === 'Q1A1' && Q2 === 'Q2A1':
        setTopMatch('Enterprise');
        setPlan('MaaS360 Enterprise');
        setDeluxe(false);
        setDeluxeData(deluxeState);
        setTopMatchDetails({
          ...topMatchDetails,
          price: enterprisePrice.toString(),
          url: marketplaceUrl.enterprise,
        });
        break;
      case Q1 === 'Q1A1' && Q2 === 'Q2A2':
        setTopMatch('Premier');
        setPlan('MaaS360 Premier');
        setDeluxe(false);
        setDeluxeData(deluxeState);
        setTopMatchDetails({
          ...topMatchDetails,
          price: premierPrice.toString(),
          url: marketplaceUrl.premier,
        });
        break;
      case Q1 === 'Q1A2' && Q2 === 'Q2A1':
        setTopMatch('Enterprise');
        setPlan('MaaS360 Enterprise');
        setDeluxe(false);
        setDeluxeData(deluxeState);
        setTopMatchDetails({
          ...topMatchDetails,
          price: enterprisePrice.toString(),
          url: marketplaceUrl.enterprise,
        });
        break;
      case Q1 === 'Q1A2' && Q2 === 'Q2A2':
        setTopMatch('Essentials');
        setPlan('MaaS360 Essentials');
        setDeluxe(true);
        setTopMatchDetails({
          ...topMatchDetails,
          price: essentialPrice.toString(),
          url: marketplaceUrl.essential,
        });
        setDeluxeData({
          ...deluxeData,
          title: intl.formatMessage(messages.deluxe_title),
          shortDesc: intl.formatMessage(messages.deluxe_short_desc),
          plan: intl.formatMessage(messages.deluxe_plan),
          icon: intl.formatMessage(messages.deluxe_icon),
          price: deluxePrice.toString(),
          url: marketplaceUrl.deluxe,
        });
        break;
    }
  };

  const toggleInvalidPB = (
    answer: string,
    setInvalid: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    if (answer === '') {
      setInvalid(true);
    } else {
      setInvalid(false);
    }
  };

  const validateStep = (step: number) => {
    switch (step) {
      case 1:
        setInvalidQ1(false);
        break;
      case 2:
        setInvalidQ2(false);
        break;
      case 3:
        setInvalidQ3(false);
        break;
      case 4:
        setInvalidQ4(false);
        break;
      case 5:
        setInvalidQ5(false);
        break;
    }
  };

  useEffect(() => {
    determineTopMatch();
  }, [que2Value, que1Value, open, step]);

  return (
    <div className="bx--grid">
      <Modal
        open={open}
        onRequestClose={handleCloseModal}
        primaryButtonText={
          noAdditionalReq && step === 4
            ? intl.formatMessage(messages.buy_here_btn)
            : step === 5
            ? intl.formatMessage(messages.results_button)
            : step === 6
            ? intl.formatMessage(messages.order_text)
            : intl.formatMessage(messages.next_btn)
        }
        secondaryButtonText={
          step > 1
            ? intl.formatMessage(messages.back_btn)
            : intl.formatMessage(messages.close_btn)
        }
        preventCloseOnClickOutside={true}
        primaryButtonDisabled={isRequired}
        onRequestSubmit={() => {
          validateStep(step);
          if (noAdditionalReq && step === 4) {
            window.open(
              packageOption !== 'Deluxe' ? topMatchDetails.url : deluxeData.url,
            );
            handleSegmentTracking('Buy now');
          } else if (!noAdditionalReq && step === 6) {
            handleUrxForm();
            handleSegmentTracking('Request a Quote');
            const q5value = que5Value.multi.selectedItems
              .map((item) => item['cookieText'])
              .join(' + ');
            const ans = [
              `Q1:${que1Value}`,
              `Q2:${que2Value}`,
              `Q3:${que3Value}`,
              `Q4:${que4Value}`,
              `Q5:${q5value}`,
            ];
            const match = !deluxePkg ? plan : DELUX_MATCH;
            useSetCookie(match, ans, cookieURL);
          } else {
            handleSegmentTracking('Next');
            setStep((step) => step + 1);
            if (!noAdditionalReq) {
              if (
                !que1Value ||
                !que2Value ||
                !que3Value ||
                !que4Value ||
                !checkQ5Value(que5Value)
              ) {
                setIsRequired(true);
              }
            }
          }
        }}
        size="lg"
        onSecondarySubmit={() => {
          if (step === 6) {
            handleSegmentTracking('Back');
            setStep((step) => step - 1);
            const style = window.document.getElementById(
              `${'urx-form-container'}`,
            ) as HTMLDivElement;
            style.style.display = 'none';
          } else {
            if (step > 1) {
              setStep((step) => step - 1);
              handleSegmentTracking('Back');
              setIsRequired(false);
            } else {
              handleCloseModal();
              handleSegmentTracking('Close');
              setStep(1);
            }
          }
        }}
      >
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            {bpName ? (
              <BusinessPartner bpName={bpName} logo={logo} urxForm={true} />
            ) : null}
          </div>
        </div>
        <div className="bx--row mt-02">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <ProgressIndicator
              spaceEqually={true}
              currentIndex={step - 1}
              onChange={(e) => {
                toggleInvalidPB(que1Value, setInvalidQ1);
                toggleInvalidPB(que2Value, setInvalidQ2);
                toggleInvalidPB(que3Value, setInvalidQ3);
                toggleInvalidPB(
                  que4Value === 0 ? '' : que4Value.toString(),
                  setInvalidQ4,
                );
                toggleInvalidPB(
                  que5Value.multi.selectedItems.length === 0
                    ? ''
                    : que5Value.multi.selectedItems
                        .map((obj) => obj.text)
                        .join(','),
                  setInvalidQ5,
                );
                setStep(e + 1);
              }}
              vertical={isSmall}
            >
              <ProgressStep
                label={<FormattedMessage {...messages.pb_question_1} />}
                secondaryLabel={que1Value}
                invalid={invalidQ1}
              />
              <ProgressStep
                invalid={invalidQ2}
                label={<FormattedMessage {...messages.pb_question_2} />}
                secondaryLabel={que2Value}
              />
              <ProgressStep
                invalid={invalidQ3}
                label={<FormattedMessage {...messages.pb_question_3} />}
                secondaryLabel={
                  trackQuesID.Q3 === 'Q3A1'
                    ? intl.formatMessage(messages.que3_opt1_short_ans_selec)
                    : trackQuesID.Q3 === 'Q3A2'
                    ? intl.formatMessage(messages.que3_opt2_short_ans_selec)
                    : trackQuesID.Q3 === 'Q3A3'
                    ? intl.formatMessage(messages.que3_opt3_short_ans_selec)
                    : trackQuesID.Q3 === 'Q3A4'
                    ? intl.formatMessage(messages.que3_opt4_short_ans_selec)
                    : ''
                }
              />
              <ProgressStep
                invalid={invalidQ4 && trackQuesID.Q3 !== 'Q3A4'}
                label={<FormattedMessage {...messages.pb_question_4} />}
                secondaryLabel={que4Value > 0 ? que4Value.toString() : ''}
                disabled={trackQuesID.Q3 === 'Q3A4'}
              />
              <ProgressStep
                invalid={invalidQ5 && trackQuesID.Q3 !== 'Q3A4'}
                label={<FormattedMessage {...messages.pb_question_5} />}
                secondaryLabel={
                  que5Value.multi.selectedItems.length > 0
                    ? `${que5Value.multi.selectedItems.length} Selected`
                    : ''
                }
                disabled={trackQuesID.Q3 === 'Q3A4'}
              />
            </ProgressIndicator>
          </div>
        </div>
        <div className={isSmall ? 'bx--row' : 'bx--row mt-02'}>
          <div className="bx--col-lg-10 bx--col-md-8 bx--col-sm-4">
            <div className={isSmall ? '' : 'mt-02'}>
              {step === 1 && (
                <Step1
                  que1Value={que1Value}
                  setQue1Value={setQue1Value}
                  setIsRequired={setIsRequired}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                />
              )}
              {step === 2 && (
                <Step2
                  que2Value={que2Value}
                  setQue2Value={setQue2Value}
                  setIsRequired={setIsRequired}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  setShowTopMatch={setShowTopMatch}
                />
              )}
              {step === 3 && (
                <Step3
                  /* todo: https://github.ibm.com/MSC-Cloud/hc-widgets/issues/974 
                     Issue to enhance questions values handling
                  */
                  que1Value={que1Value}
                  que2Value={que2Value}
                  que3Value={que3Value}
                  setQue3Value={setQue3Value}
                  setIsRequired={setIsRequired}
                  noAdditionalReq={noAdditionalReq}
                  setNoAdditionalReq={setNoAdditionalReq}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                />
              )}
              {step === 4 && !noAdditionalReq && (
                <Step4
                  que4Value={que4Value}
                  setQue4Value={setQue4Value}
                  setIsRequired={setIsRequired}
                />
              )}
              {step === 4 && noAdditionalReq && (
                <>
                  <PackageDetail
                    data={topMatchDetails}
                    deluxe={deluxe}
                    deluxeData={deluxeData}
                    noAdditionalReq={noAdditionalReq}
                  />
                  {deluxe && (
                    <div className="mar2">
                      <span className="page_sub_heading_2">
                        <FormattedMessage {...messages.plan_buy_text} />
                      </span>
                      <Switcher
                        packageOption={packageOption}
                        setPackageOption={setPackageOption}
                        deluxePkg={deluxePkg}
                        setDeluxePkg={setDeluxePkg}
                        topMatch={topMatch}
                        handleSegmentTracking={handleSegmentTracking}
                      />
                    </div>
                  )}
                </>
              )}
              {step === 5 && !noAdditionalReq && (
                <Step5
                  que1Value={que1Value}
                  que2Value={que2Value}
                  que3Value={que3Value}
                  que4Value={que4Value}
                  que5Value={que5Value}
                  setQue5Value={setQue5Value}
                  setIsRequired={setIsRequired}
                  checkboxState={!checkQ5Value(que5Value)}
                />
              )}
              {step === 6 && (
                <>
                  <Result
                    data={topMatchDetails}
                    deluxe={deluxe}
                    deluxeData={deluxeData}
                    noAdditionalReq={false}
                  />
                  {deluxe && (
                    <div>
                      <span className="page_sub_heading_2">
                        <FormattedMessage {...messages.request_plan_text} />
                      </span>
                      <Switcher
                        packageOption={packageOption}
                        setPackageOption={setPackageOption}
                        deluxePkg={deluxePkg}
                        setDeluxePkg={setDeluxePkg}
                        topMatch={topMatch}
                        handleSegmentTracking={handleSegmentTracking}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="bx--col-lg-6 bx--col-md-8 bx--col-sm-4">
            {que1Value && (
              <div className="results">
                <div className="reset-item" onClick={handleReset}>
                  <span>
                    <FormattedMessage {...messages.start_over} />
                  </span>
                  <Restart20 className="restart-icon" />
                </div>
                <div className="selection">
                  <FormattedMessage {...messages.your_selection} />
                </div>
                <ul>
                  {que1Value && (
                    <Selection
                      state={intl.formatMessage(messages.q1_selec_key)}
                      answer={que1Value}
                      quesID={trackQuesID.Q1}
                    />
                  )}
                  {que2Value && (
                    <Selection
                      state={intl.formatMessage(messages.q2_selec_key)}
                      answer={que2Value}
                      quesID={trackQuesID.Q2}
                    />
                  )}
                  {que3Value && (
                    <Selection
                      state={intl.formatMessage(messages.q3_selec_key)}
                      answer={que3Value}
                      quesID={trackQuesID.Q3}
                    />
                  )}
                  {que4Value > 0 && (
                    <Selection
                      state={intl.formatMessage(messages.q4_selec_key)}
                      answer={que4Value}
                    />
                  )}
                  {checkQ5Value(que5Value) && (
                    <Selection
                      state={intl.formatMessage(messages.q5_selec_key)}
                      arrAns={que5Value.multi.selectedItems}
                    />
                  )}
                </ul>
              </div>
            )}
            {topMatch && noAdditionalReq && step === 4 ? null : topMatch &&
              step < 6 ? (
              <TopMatch data={topMatchDetails} />
            ) : null}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Assessment;
